import React from "react";
import { EditableArea } from "@magnolia/react-editor";

/**
 * Renders one campaign fragment (creative) inside the Campaign Manager app's WYSIWYG.
 *
 * The twin of ComponentFactoryItem: a creative is a fragment meant to be embedded through
 * the managed-campaign component, not a page of its own, so no header/navigation/footer.
 * The area stays editable — the campaign WYSIWYG draws its bars via the campaign-manager
 * template-annotations endpoint (feature-campaign-manager:restEndpoints).
 */
const CampaignFragmentItem = ({ main }) => (
    <div className="campaign-fragment">{main && <EditableArea content={main} />}</div>
);

export default CampaignFragmentItem;